import { render, staticRenderFns } from "./DrawingReviewList.vue?vue&type=template&id=06ea82d8&scoped=true"
import script from "./DrawingReviewList.vue?vue&type=script&lang=js"
export * from "./DrawingReviewList.vue?vue&type=script&lang=js"
import style0 from "./DrawingReviewList.vue?vue&type=style&index=0&id=06ea82d8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ea82d8",
  null
  
)

export default component.exports